module.exports = __webpack_public_path__ + "img/bg.02f78963.png";